<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block">
      <revenue-share-sub-header :sub-header="currentStep === 2 ? step2HeaderText : headerText" />
      <split-information-link />
      <div class="page-block__inner">
        <release-step-area
          :index="currentStep"
          :is-revenue-page="true">
        </release-step-area>
        <div class="my-release-search-wrap">
          <revenue-share-top-section
            :title="releaseData.title"
            :img-src="releaseData.coverart_filepath"
            :artist-name="releaseData.artist_name"
            :release-type="releaseData.type"
            :date="releaseData.created_at" />
          <revenue-sharing-form
            v-if="showForm"
            :form-fields-data="trackForms"
            :errors-data="errors"
            :tracks="tracks"
            :release-type="releaseData.type"
            :percentage-error="percentageError"
            :percentage-data="percentage"
            @viewForm="viewForm" />
          <form
            v-if="!showForm"
            @submit.prevent="submitForm">
            <div
              v-for="(track,i) in trackForms"
              :key="i">
              <div class="form-title">{{ `${i+1}.` }} {{ tracks[i].titles[0].title }}</div>
              <revenue-share-form-table
                :form="track" />
              <p class="form-btn-area-top"></p>
            </div>
            <revenue-share-form-bottom-area
              :confirm-button="'スプリットを登録する'"
              :back-button="'編集画面へ戻る'"
              @submitForm="submitForm"
              @viewForm="viewForm" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReleaseStepArea from '../Release/StepArea'
import HeaderBar from '../HeaderBar'
import SplitInformationLink from './SplitInformationLink'
import RevenueShareTopSection from './RevenueShareTopSection'
import RevenueShareFormTable from './RevenueShareFormTable'
import RevenueShareFormBottomArea from './RevenueShareFormBottomArea'
import RevenueSharingForm from './RevenueSharingForm'
import RevenueShareSubHeader from './RevenueShareSubHeader'

export default {
  name: 'Step2Album',
  components: {
    RevenueSharingForm,
    RevenueShareFormBottomArea,
    RevenueShareFormTable,
    RevenueShareTopSection,
    SplitInformationLink,
    ReleaseStepArea,
    HeaderBar,
    RevenueShareSubHeader,
  },
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  data() {
    return {
      releaseData: {
        coverart_filepath: '',
        title: '',
        artist_name: '',
        type: '',
        discs: [],
      },
      tracks: [],
      errors: [],
      trackForms: [],
      showForm: true,
      currentStep: 2,
      productDiscTrackId: '',
      disableSubmitButton: false,
      productDiscTracksInRevenueShare: [],
      productId: '',
      percentageError: [],
      percentage: [],
      step2HeaderText: 'スプリット設定',
      headerText: 'スプリット設定内容確認',
    }
  },
  async mounted() {
    const { id } = this.$route.params
    const { productId } = JSON.parse(window.sessionStorage.getItem('split')) || {}
    // check whether current processing productId and id of query params match or not.
    if (!productId || parseInt(productId, 10) !== parseInt(id, 10)) {
      this.$router.push({ name: 'index' })
      return
    }
    this.productId = id
    await this.getRevenueShareByProductId(id)
    await this.getProductById(id)
  },
  methods: {
    async getProductById(id) {
      try {
        const { data } = await window.axios.get(`/api/client/products/${id}`)
        this.releaseData = data
        Object.keys(this.releaseData.discs).forEach(discIndex => {
          const disc = this.releaseData.discs[discIndex]
          Object.keys(disc.tracks).forEach(trackIndex => {
            const track = disc.tracks[trackIndex]
            this.tracks.push(track)
            const x = this.productDiscTracksInRevenueShare
              .filter(item => item.product_disc_track_id === track.id)
            if (x.length > 0) {
              const newTrackFormArray = []
              const newTrackFormErr = []
              x.forEach((item) => {
                newTrackFormArray.push({
                  rate: item.rate,
                  email: item.email,
                  memo: item.memo,
                  role: item.role,
                  owner: item.owner,
                  product_disc_track_id: item.product_disc_track_id,
                  product_id: item.product_id,
                  isDisabled: true,
                })
                newTrackFormErr.push({
                  rate: '',
                  email: '',
                  role: '',
                })
              })
              this.trackForms.push(newTrackFormArray)
              this.errors.push(newTrackFormErr)
            } else {
              this.trackForms.push([
                {
                  rate: '',
                  email: this.$store.state.auth.email,
                  memo: '',
                  role: '',
                  owner: 1,
                  product_disc_track_id: track.id,
                  product_id: this.productId,
                },
              ])
              this.errors.push([{
                rate: '',
                email: '',
                role: '',
              }])
            }
          })
        })
      } catch (e) {
        await this.$router.push('/client')
      }
    },
    async getRevenueShareByProductId(id) {
      const { data } = await window.axios.get('/api/client/revenueShare', { params: { product_id: id } })
      this.productDiscTracksInRevenueShare = data.data.map(item => ({
        email: item.email,
        rate: item.rate,
        memo: item.memo,
        role: item.role,
        owner: item.owner,
        product_disc_track_id: item.product_disc_track_id,
        product_id: item.product_id,
      }))
    },
    viewForm(event) {
      if (event) {
        this.currentStep = 2
        this.showForm = true
      } else {
        this.showForm = false
        this.currentStep = 3
      }
    },
    async submitForm() {
      const newTrackForms = []
      this.trackForms.forEach((item) => {
        const isPresent = this.productDiscTracksInRevenueShare
          .some(rsElement => rsElement.product_disc_track_id === item[0].product_disc_track_id)
        if (!isPresent) {
          newTrackForms.push(item)
        }
      })
      try {
        await window.axios.post('/api/client/revenueShare/createAlbum', newTrackForms)
        await this.$router.push({
          name: 'revenue-share-registration-completion',
          query: {
            title: this.releaseData.title,
            type: this.releaseData.type,
            id: this.productId,
          },
        })
      } catch (error) {
        if (error.response.status === 422) {
          const { errors } = error.response.data
          this.formatValidationErrorsFromBackend(errors)
        }
      }
    },
    formatValidationErrorsFromBackend(errors) {
      this.showForm = true
      Object.keys(errors).forEach(key => {
        if (key === 'fullPercentError' || key === 'zeroPercentError') {
          this.trackForms.forEach((item, index) => {
            // eslint-disable-next-line prefer-destructuring
            this.percentageError[index] = errors[key][0]
          })
        } else if (key.split('.')[1] === 'percentageError') {
          const index1 = parseInt(key.split('.')[0], 10)
          // eslint-disable-next-line prefer-destructuring
          this.percentageError[index1] = errors[key][0]
        } else {
          const index1 = parseInt(key.split('.')[0], 10)
          const index2 = parseInt(key.split('.')[1], 10)
          const field = key.split('.')[2]
          const errorMessage = errors[key][0]
          const err = this.errors[index1][index2]
          if (field === 'rate') {
            err.rate = errorMessage
          } else if (field === 'email') {
            err.email = errorMessage
          } else if (field === 'role') {
            err.role = errorMessage
          }
          this.errors[index1].splice(index2, 1, err)
        }
      })
    },
  },
}
</script>

<style scoped>
.my-release-search-wrap {
  height: auto;
  display: block;
  background: white;
}

table {
  width: -webkit-fill-available;
  margin: 10px 0;
  border-collapse: separate;
  border-spacing: 10px;
}

th, td {
  padding: 4px 0px !important;
}

th {
  text-align: initial;
}

.my-release-search-wrap .form-wrap {
  padding: 0 10px;
}

.form-btn-area-top svg {
  height: 20px;
  width: 13px;
  margin-right: 10px;
  margin-top: 5px;
  color: white;
}

.my-release-search-wrap .form-group .form-label {
  width: 100px;
}

.form-btn-area-top button {
  color: black;
  font-weight: normal;
}

.form-group-large {
  width: -webkit-fill-available !important;
}

.form-item {
  position: relative;
}

.form-item p {
  position: absolute;
}

.row {
  margin-bottom: 14px;
}

.form-group {
  padding: 14px 0 !important;
  border: none;
}

</style>
